import { Action } from '@ngrx/store';

export enum UserActionTypes {
  REQUEST_INVITATION_LINK = '[Users] Request Invitation Link',
  REQUEST_INVITATION_LINK_SUCCESS = '[Users] Request Invitation Link Success',
  REQUEST_INVITATION_LINK_FAILURE = '[Users] Request Invitation Link Failure',
}

export class RequestInvitationLink implements Action {
  readonly type = UserActionTypes.REQUEST_INVITATION_LINK;
  constructor(public payload: string) {}
}

export class RequestInvitationLinkSuccess implements Action {
  readonly type = UserActionTypes.REQUEST_INVITATION_LINK_SUCCESS;
  constructor(public payload: string) {}
}

export class RequestInvitationLinkFailure implements Action {
  readonly type = UserActionTypes.REQUEST_INVITATION_LINK_FAILURE;
}

export type UserActions =
  | RequestInvitationLink
  | RequestInvitationLinkSuccess
  | RequestInvitationLinkFailure;
